import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconMarkdown: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"markdown"} maskId="square-filled-radius-0-stroke-1-IconMarkdown"><path fillRule="evenodd" clipRule="evenodd" d="M2 20V4H22V20H2ZM6 9V15H7V10.5575L8.67053 12.5H9.32947L11 10.5575V15H12V9H11.0205L9 11.3495L6.97947 9H6ZM17 9H16V13.2929L14.5 11.7929L13.7929 12.5L16.4985 15.2056L19.2071 12.5203L18.5031 11.8101L17 13.3002V9Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconMarkdown;
